import { Select as ShellSelect } from '@e3dc-react/shell/Elements/Select'
import { ShellSelectProps } from '@e3dc-react/shell/Elements/Select/FeatureRichSelect'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type SearchableSelectProps<T> = {
  name: string
  onChange?: (value: T) => void
} & Omit<ShellSelectProps<T>, 'value' | 'onChange' | 'isSearchable'>

/**
 * Shell searchable select integrated with react-hook-form.
 */
const SearchableSelect = <T,>({ name, onChange, ...props }: SearchableSelectProps<T>): React.ReactElement => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <ShellSelect
          {...props}
          value={field.value as T}
          onChange={value => {
            field.onChange(value)
            onChange?.(value)
          }}
          isSearchable
          helperText={error?.message}
          error={error?.message}
          useTooltipErrorMessage={false}
          menuShouldBlockScroll={false}
        />
      )}
    />
  )
}

export default SearchableSelect
